import { SessionStatus } from '@heidi/schema/ml-scribe';

type StartNowConsumableSession = {
  session_id?: string | null;
  duration?: number | null;
  session_status?: SessionStatus | string | null;
};

/**
 * Whether Start is spent for a session: its stop/save is still in flight
 * (`stoppedSessionIds`, dropped on save or note-generation failure so Start
 * returns), or it already carries work (any status past `EMPTY`). Duration
 * alone does not consume Start — a too-short transcript still leaves `EMPTY`
 * and the clinician needs Start back.
 *
 * Also marks a later-today appointment as commenced for session-list
 * presentation grouping, so active/stopped/processed rows remain in Today.
 */
export function isStartNowConsumedSession(
  session: StartNowConsumableSession,
  stoppedSessionIds?: ReadonlySet<string> | null
): boolean {
  if (session.session_id && stoppedSessionIds?.has(session.session_id)) {
    return true;
  }
  const status = session.session_status;
  return status != null && String(status) !== String(SessionStatus.EMPTY);
}
